import { css } from 'linaria';

export const bathroomCollectionsListGrid = css`
  display: grid;
  grid-auto-rows: 378px;
  grid-template-columns: repeat(3, 377px);
  padding: 0;
  margin: 0;
  column-gap: 24px;
  list-style: none;
  row-gap: 24px;

  @media (--only-desktop) {
    grid-template-columns: repeat(2, 458px);
  }

  @media (--only-tablet) {
    grid-auto-rows: 326px;
    grid-template-columns: repeat(2, 318px);
  }

  @media (--only-mobile) {
    grid-template-columns: repeat(1, 100%);
    column-gap: 0;
    row-gap: 16px;
  }
`;

export const bathroomCollectionsListLink = css`
  && {
    height: 100%;
  }
`;

export const bathroomCollectionsListLinkDisabled = css`
  && {
    cursor: default;
    pointer-events: none;
  }
`;

export const bathroomCollectionsListImage = css`
  display: block;
  width: 100%;
  height: 236px;
  border-radius: var(--rounding-l) var(--rounding-l) 0 0;
  object-fit: cover;

  @media (--only-tablet) {
    height: 184px;
  }
`;

export const bathroomCollectionsListName = css`
  && {
    margin-bottom: 14px;
  }
`;

export const bathroomCollectionsListPrice = css`
  && {
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
  }
`;

export const bathroomCollectionsListButton = css`
  && {
    padding: 10px;
    margin-top: auto;
    text-align: center;
    background-color: var(--control-minor);
    border-radius: var(--rounding-m);

    a:hover & {
      background-color: var(--control-hover-minor);
    }
  }
`;

export const bathroomCollectionsListButtonDisabled = css`
  && {
    padding: 8px;
    margin-top: auto;
    text-align: center;
    background-color: transparent;
    border: 2px solid var(--control-secondary);
    border-radius: var(--rounding-m);
    opacity: 0.4;
    user-select: none;
  }
`;
